export const categoryTypes = {
    'en': [
        { title: 'Any Category', value: 'all' },
        { title: 'Condo', value: 'condo' },
        { title: 'House', value: 'house' },
        { title: 'Land', value: 'land' },
        { title: 'Commercial', value: 'commercial' }
    ],
    'th': [
        { title: 'ประเภท', value: 'all' },
        { title: 'คอนโด', value: 'condo' },
        { title: 'บ้าน', value: 'house' },
        { title: 'ที่ดิน', value: 'land' },
        { title: 'เชิงพาณิชย์', value: 'commercial' }
    ],
    'cn': [
        { title: '房产类型', value: 'all' },
        { title: '公寓', value: 'condo' },
        { title: '别墅', value: 'house' },
        { title: '土地', value: 'land' },
        { title: '工商', value: 'commercial' }
    ],
    'ru': [
        { title: 'Любой', value: 'all' },
        { title: 'Вилла', value: 'house' },
        { title: 'Земля', value: 'land' },
        { title: 'Квартира', value: 'condo' },
        { title: 'Коммерческая', value: 'commercial' }
    ],
    'de': [
        { title: 'Beliebig', value: 'all' },
        { title: 'Villa', value: 'house' },
        { title: 'Grundstück', value: 'land' },
        { title: 'Eigentumswohnung', value: 'condo' },
        { title: 'Gewerbe', value: 'commercial' }
    ],
    'fr': [
        { title: "N'importe quel", value: 'all' },
        { title: 'Villa', value: 'house' },
        { title: 'Terrain', value: 'land' },
        { title: 'Appartement', value: 'condo' },
        { title: 'Commercial', value: 'commercial' }
    ],
    'it': [
        { title: 'Qualsiasi', value: 'all' },
        { title: 'Condominio', value: 'condo' },
        { title: 'Casa', value: 'house' },
        { title: 'Terreno', value: 'land' },
        { title: 'Commerciale', value: 'commercial' }
    ],
    'ja': [
        { title: 'すべてのカテゴリ', value: 'all' },
        { title: 'コンドミニアム', value: 'condo' },
        { title: '一戸建て', value: 'house' },
        { title: '土地', value: 'land' },
        { title: '商業施設', value: 'commercial' }
    ],
    'ko': [
        { title: '모든 카테고리', value: 'all' },
        { title: '콘도/아파트', value: 'condo' },
        { title: '주택', value: 'house' },
        { title: '토지', value: 'land' },
        { title: '상업용', value: 'commercial' }
    ],
    'es': [
        { title: 'Cualquier categoría', value: 'all' },
        { title: 'Piso', value: 'condo' },
        { title: 'Casa', value: 'house' },
        { title: 'Terreno', value: 'land' },
        { title: 'Comercial', value: 'commercial' }
    ],
    'tr': [
        { title: 'Tüm Kategoriler', value: 'all' },
        { title: 'Daire', value: 'condo' },
        { title: 'Müstakil Ev', value: 'house' },
        { title: 'Arsa', value: 'land' },
        { title: 'Ticari', value: 'commercial' }
    ],
    'he': [
        { title: 'כל הקטגוריות', value: 'all' },
        { title: 'דירה/קונדו', value: 'condo' },
        { title: 'בית פרטי', value: 'house' },
        { title: 'קרקע', value: 'land' },
        { title: 'מסחרי', value: 'commercial' }
    ],
    'ar': [
        { title: 'جميع الفئات', value: 'all' },
        { title: 'شقة', value: 'condo' },
        { title: 'منزل', value: 'house' },
        { title: 'أرض', value: 'land' },
        { title: 'تجاري', value: 'commercial' }
    ]
}